
interface StatsCardProps {
  label: string;
  value: string;
  description: string;
}

const StatsCard = ({ label, value, description }: StatsCardProps) => {
  return (
    <div className="flex flex-col py-6 border-b border-gray-200 last:border-b-0">
      <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
        {value}
      </div>
      <div className="text-sm text-gray-600 flex items-center gap-2">
        {description}
        <button className="text-gray-400 hover:text-gray-600 transition-colors">
          <i className="ri-information-line text-sm"></i>
        </button>
      </div>
    </div>
  );
};

export default StatsCard;
